import { Navigate } from '@report/router';

export default function HomePage() {
  return <Navigate to='/reports' replace />;
}
